import { render, staticRenderFns } from "./ifood-widget.vue?vue&type=template&id=3699bd4a&scoped=true"
import script from "./ifood-widget.vue?vue&type=script&lang=js"
export * from "./ifood-widget.vue?vue&type=script&lang=js"
import style0 from "./ifood-widget.vue?vue&type=style&index=0&id=3699bd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699bd4a",
  null
  
)

export default component.exports